var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "34", height: "34", viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "34", height: "34", rx: "10", fill: "#5B6FD7" }),
    React.createElement("path", { d: "M20.606 23.11l-.001.001c-.738.553-1.849.838-3.347.838h-4.923a.1.1 0 0 1-.1-.1v-6.283a.1.1 0 0 1 .1-.1h4.923c1.517 0 2.636.272 3.375.8.732.524 1.102 1.31 1.102 2.377 0 1.1-.38 1.917-1.13 2.467zM9.46 25.604a.6.6 0 0 0 .6.6h7.301c2.283 0 4.05-.48 5.289-1.452 1.258-.975 1.884-2.367 1.884-4.162 0-1.74-.572-3.08-1.727-4.004-1.152-.922-2.825-1.375-5.004-1.375h-5.569v-4.9a.1.1 0 0 1 .1-.1h10.456a.6.6 0 0 0 .6-.6V8.4a.6.6 0 0 0-.6-.6h-12.73a.6.6 0 0 0-.6.6v17.204z", fill: "#fff", stroke: "#fff", strokeWidth: ".2" })
  );
});